"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoginViewSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _students = _interopRequireDefault(require("./assets/students.png"));
var _teacherAndParents = _interopRequireDefault(require("./assets/teacher-and-parents.png"));
var _state = require("./state");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LOGIN_TILES = [{
  index: 0,
  label: 'Student',
  avatar: _students["default"],
  hash: '#student',
  clickedOn: "Class",
  clickedOnDesc: "Classroom",
  dataTestId: 'login-tile-student'
}, {
  index: 1,
  label: 'Teacher/Parent',
  avatar: _teacherAndParents["default"],
  hash: '#parent',
  clickedOn: "Teacher and Parent",
  dataTestId: 'login-tile-teacher-and-parent'
}];
var Tile = function Tile(_ref) {
  var _ref$tile = _ref.tile,
    tile = _ref$tile === void 0 ? {} : _ref$tile;
  var _useAuthSigninState = (0, _state.useAuthSigninState)(),
    sendEvent = _useAuthSigninState.sendEvent;
  var tilesOnClickHandler = function tilesOnClickHandler(tile) {
    window.location.href = tile.hash;
    trackPageViewOnGa('login-popup');
    trackAnalyticsEvent("Clicked ".concat(tile.clickedOn, " icon"), {
      "Source": 'Signin Popup',
      "Intent For": 'signin',
      "Clicked On": "".concat(tile.clickedOnDesc || tile.clickedOn),
      "Platform": 'web'
    });
    sendEvent("Login as ".concat(tile.label));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "login-tile",
    onClick: function onClick() {
      return tilesOnClickHandler(tile);
    },
    "data-test-id": tile === null || tile === void 0 ? void 0 : tile.dataTestId,
    "data-sentry-component": "Tile",
    "data-sentry-source-file": "loginViewSelector.tsx"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: tile.avatar,
    alt: tile.avatar
  }), /*#__PURE__*/_react["default"].createElement("h4", null, tile.label));
};
var LoginViewSelector = exports.LoginViewSelector = function LoginViewSelector() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "login-view-selector",
    "data-sentry-component": "LoginViewSelector",
    "data-sentry-source-file": "loginViewSelector.tsx"
  }, /*#__PURE__*/_react["default"].createElement("h4", null, "Log In as"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "login-tiles"
  }, LOGIN_TILES.map(function (tile) {
    return /*#__PURE__*/_react["default"].createElement(Tile, {
      tile: tile,
      key: tile.index
    });
  })));
};